import ProductDetailCollapse from './ProductDetailCollapse.jsx';

export {
  ProductDetailCollapse
}


// WEBPACK FOOTER //
// ./components/product-detail/sub-view/product-detail/index.js